import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "feedback-page" }
const _hoisted_2 = { class: "feedback-layout" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { style: {"text-align":"center","padding":"32px 0"} }

import { ref } from 'vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackManager',
  setup(__props) {

const tabKey = ref('todo')

const columns = [
  { title: '反馈ID', dataIndex: 'id', key: 'id' },
  { title: '反馈用户账号', dataIndex: 'user', key: 'user' },
  { title: '反馈类型', dataIndex: 'type', key: 'type' },
  { title: '反馈内容', dataIndex: 'content', key: 'content' },
  { title: '联系方式', dataIndex: 'contact', key: 'contact' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', key: 'action' }
]

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "feedback-title" }, "问题反馈", -1)),
            _createVNode(_component_a_tabs, {
              activeKey: tabKey.value,
              "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((tabKey).value = $event)),
              style: {"margin-bottom":"16px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "todo",
                  tab: "待受理"
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "doing",
                  tab: "受理中"
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "done",
                  tab: "已完成"
                })
              ]),
              _: 1
            }, 8, ["activeKey"]),
            _createVNode(_component_a_table, {
              columns: columns,
              "data-source": [],
              pagination: false,
              size: "middle",
              style: {"margin-top":"8px"}
            }, {
              emptyText: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_empty, { description: "暂无数据" })
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})